
import { useState } from "react";
import QcLogicFormField from "./QcLogicFormField";

const AddQcLogicForm = () => {


    const [crumbs] = useState([
            {content: "Home", url: "/home"},
            {content: "QC Logics", url: "/qc-logics"},
            {content: "Add Qc Logic", url: ""}
        ]
    )

    return (
        <>
            <QcLogicFormField crumbs={crumbs} title={"Add Qc Rule"} btnText={"Create"}/>
        </>
    )

}
export default AddQcLogicForm;